import { ENV } from '../ENV'

const Base_Url = ENV.connection.server_base_url
export const SocketUrl = ENV.connection.websocket_base_url

const ApiEndpoint = {
  signup: Base_Url + 'users/signup',
  signupCompanyDetails: Base_Url + 'users/signupCompanyDetails',
  getEmailOPT: Base_Url + 'users/getEmailOPT',
  verifyOTP: Base_Url + 'users/verifyOTP',
  login: Base_Url + 'users/login',
  logout: Base_Url + 'users/logout',
  changepassword: Base_Url + 'users/changepassword',
  forgotpassword: Base_Url + 'users/forgotpassword',
  resetpassword: Base_Url + 'users/resetpassword',
  activateaccount: Base_Url + 'users/activateAccount',
  getjobpostdropdownvalues: Base_Url + 'getjobpostdropdownvalues',
  getCountries: Base_Url + 'getcountries',
  getJobPosts: Base_Url + 'employer/getjobposts',
  postJob: Base_Url + 'employer/postjob',
  editPostedJob: Base_Url + 'employer/editpostedjob',
  closeJob: Base_Url + 'employer/closejob',
  discardJob: Base_Url + 'employer/discardjob',
  preQuestions: Base_Url + 'employer/getprequestions',
  rejectedReasons: Base_Url + 'employer/getrejectionreasons',
  searchJobs: Base_Url + 'recruiter/searchjobs',
  addToWorklist: Base_Url + 'recruiter/addtoworklist',
  getWorklist: Base_Url + 'recruiter/getworklist',
  removeFromWorklistURL: Base_Url + 'recruiter/removeFromWorklist',
  removeReasonFromWorklistURL: Base_Url + 'recruiter/removeReasonFromWorklist',
  submitCandidateURL: Base_Url + 'recruiter/postCandidateApplication',
  getWorkOnURL: Base_Url + 'recruiter/getCandidateApplications',
  getSubEmployers: Base_Url + 'employer/getsubemployer',
  checkCandidateURL: Base_Url + 'recruiter/checkCandidate',
  getCandidateURL: Base_Url + 'recruiter/trackCandidates',
  editCandidateURL: Base_Url + 'recruiter/editCandidateApplication',
  candidatePostApplicationEmailURL:
    Base_Url + 'recruiter/getCandiatePostApplicationEmailPreview',
  resentCandidateApplicationEmailURL:
    Base_Url + 'recruiter/resendCandidateApplicationEmail',
  getJobDetailsForCandidateURL: Base_Url + 'users/getJobDetailsForCandidate',
  approveCandidateApplicationURL:
    Base_Url + 'users/approvecandidateapplication',
  rejectCandidateApplicationURL: Base_Url + 'users/rejectcandidateapplication',
  getProfileData: Base_Url + 'employer/getprofile',
  editEmployerProfileURL: Base_Url + 'employer/updateprofile',
  getDashboardData: Base_Url + 'employer/getdashboard',
  getRecruiterDashboardData: Base_Url + 'recruiter/getDashboardData',
  getReferralEarningsURL: Base_Url + 'recruiter/getReferralEarnings',
  getApplicationsForReviewURL: Base_Url + 'employer/getApplicationsForReview',
  changeApplicationStatusURL: Base_Url + 'employer/changeApplicationStatus',
  changeJoiningDate: Base_Url + 'employer/changeJoiningDate',
  getNotificationDataURL: Base_Url + 'users/getNotifications',
  markAsReadNotification: Base_Url + 'users/markAsReadNotification',
  getJobsPostedByEmployer: Base_Url + 'recruiter/getJobsPostedByEmployer',
  getNotificationsCount: Base_Url + 'users/getNotificationsCount',
  updateHiredApplicationStatus:
    Base_Url + 'employer/updateHiredApplicationStatus',
  getEmailPreferences: Base_Url + 'recruiter/getEmailPreferences',
  updateEmailPreferences: Base_Url + 'recruiter/updateEmailPreferences',
  putOnHoldOrActiveURL: Base_Url + 'employer/putOnHoldOrActive',
  getTransactions: Base_Url + 'employer/getalltransactions',
  addSubEmployerURL: Base_Url + 'employer/addsubemployer',
  assignSubEmployerURL: Base_Url + 'employer/assignSubEmployers',
  getRecruiterProfile: Base_Url + 'recruiter/getRecruiterProfile',
  updateRecruiterProfile: Base_Url + 'recruiter/updateRecruiterProfile',
  candidateUpdateApplicationURL: Base_Url + 'users/candidateUpdateApplication',
  feedbackOnRecruiterURL: Base_Url + 'users/feedbackOnRecruiter',
  getMyFunctionalRoles: Base_Url + 'recruiter/getMyFunctionalRoles',
  sendMessage: Base_Url + 'recruiter/sendMessage',
  markMessageAsSeen: Base_Url + 'recruiter/markMessageAsSeen',
  editMessage: Base_Url + 'recruiter/editMessage',
  deleteMessage: Base_Url + 'recruiter/deleteMessage',
  getFAQurl: Base_Url + 'getFAQs',
  setPasswordSubEmployer: Base_Url + 'employer/setPasswordSubEmployer',
  resendSubEmployerEmail: Base_Url + 'employer/resendSubEmployerEmail',
  deleteQuestionFromLibrary: Base_Url + 'employer/deleteQuestionFromLibrary',
  getStateAndCityByZipcode: Base_Url + 'getStateAndCityByZipcode',

  getStateAndCityByZipcodeUsers:
    Base_Url + 'users/getStateAndCityByZipcodeUsers',
  getSkillSuggestionsURL: Base_Url + 'employer/getSkillSuggestions',
  submitEmployeeFeedbackURL: Base_Url + 'employer/submitEmployeeFeedback',
  getEmployeeFeedbackURL: Base_Url + 'employer/getEmployeeFeedback'
}
export default ApiEndpoint
